import { render, staticRenderFns } from "./MergeAliasForm.vue?vue&type=template&id=50c41271"
import script from "./MergeAliasForm.vue?vue&type=script&lang=js"
export * from "./MergeAliasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports